<template>
    <div>
        <el-alert type="warning" title="注意事项：">
            <div>1、拍摄前，请确保相机日期和时钟的正确设置，以便后台系统根据拍摄时间划分时间段；</div>
            <div>2、支持批量上传，一次性最多上传50张照片；</div>
            <div>3、批量上传前，可用LightRoom设置参数的方式进行批量修图，无须每一张进行修图处理；</div>
            <div>4、本工具只接受上传文件大于1M、 或者像素超过1000万的JPG格式照片；</div>
            <!-- <div>5、上传过程中，如果遇到上传失败或页面崩溃，可重新上传。系统将自动过滤已经上传过的照片；</div>
            <div>6、上传失败的照片，可将鼠标移动到照片状态列红色"!" 查看原因；</div> -->
            <div>5、照片拍摄完成后，尽可能在2小时内及时完成上传。</div>
        </el-alert>
        <el-steps :active="steps" simple finish-status="success" class="MT20">
            <el-step title="关联演出"></el-step>
            <el-step title="上传照片"></el-step>
        </el-steps>
        <div v-show="steps == 0" class="steps1 MT20">
            <add-steps-1 :form-data.sync="formData" :steps.sync="steps"></add-steps-1>  
        </div>
        <div v-show="steps == 1" class="steps2 MT20">
            <add-steps-2 :form-data.sync="formData"></add-steps-2>  
        </div>
    </div>
</template>

<script>
import AddSteps1 from './components/AddSteps1.vue';
import AddSteps2 from './components/AddSteps2.vue';
export default {
    components: {AddSteps1, AddSteps2},
    data() {
        return {
            steps: 0,
            formData: {
                activityId: "",
                // file: "",
                // shootingTime: "",
                tagsId: "",
                userId: ""
            },
        }
    },
    created(){
        const _activityId = this.$route.query.activityId || ''
        if( _activityId ){
            this.formData.activityId = _activityId;
            this.steps = 1;
        }
    },
    mounted() {
        this.formData.userId = this.$store.state.userInfo.id
    },
    methods: {
        
    }
}
</script>

<style lang="scss" scoped>

</style>